'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GuideEnterprise = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(GuideEnterprise, _Component);

  function GuideEnterprise() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GuideEnterprise);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GuideEnterprise.__proto__ || (0, _getPrototypeOf2.default)(GuideEnterprise)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // CODE TEST: PA2019_LMDN


  (0, _createClass3.default)(GuideEnterprise, [{
    key: 'render',
    value: function render() {
      var styles = require('./GuideEnterprise.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.enterprise },
        _react2.default.createElement(
          'div',
          { className: styles.head },
          'H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng m\xE3 \u01B0u \u0111\xE3i'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 1: T\xECm ki\u1EBFm "Lookme.vn" tr\xEAn App Store, t\u1EA3i v\xE0 c\xE0i \u0111\u1EB7t App'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-1.png', alt: 'buoc-1' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 2: V\xE0o t\xE0i kho\u1EA3n v\xE0 \u0111\u0103ng nh\u1EADp b\u1EB1ng s\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-2.png', alt: 'buoc-2' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 3: V\xE0o t\xE0i kho\u1EA3n v\xE0 v\xE0o \u01AFu \u0111\xE3i \u0111\u1ED1i t\xE1c'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-3.png', alt: 'buoc-3' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 4: Nh\u1EADp m\xE3 \u01B0u \u0111\xE3i v\xE0 b\u1EA5m S\u1EED d\u1EE5ng'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-4.png', alt: 'buoc-4' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 5: Ch\u1ECDn 1 trong c\xE1c d\u1ECBch v\u1EE5'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-5.png', alt: 'buoc-5' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 6: B\u1EA5m n\xFAt Ch\u1ECDn \u01B0u \u0111\xE3i'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-6.png', alt: 'buoc-6' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 7: B\u1EA5m n\xFAt Ch\u1EAFc ch\u1EAFn'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-7.png', alt: 'buoc-7' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 8: B\u1EA5m n\xFAt Xong'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-8.png', alt: 'buoc-8' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 9: B\u1EA5m n\xFAt G\u1ECDi \u0111\u1EB7t l\u1ECBch \u0111\u1EC3 \u0111\u1EB7t l\u1ECBch tr\u01B0\u1EDBc khi \u0111\u1EBFn s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-9.png', alt: 'buoc-9' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.enterRow },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u01B0\u1EDBc 10: Tr\xECnh m\xE0n h\xECnh \u01B0u \u0111\xE3i c\xF3 m\xE3 code khi \u0111\u1EBFn s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement('img', { src: '/guide/buoc-10.png', alt: 'buoc-10' })
          )
        )
      );
    }
  }]);
  return GuideEnterprise;
}(_react.Component), _class.propTypes = {}, _temp2);
exports.default = GuideEnterprise;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Enterprise/GuideEnterprise.js
// module id = 1595
// module chunks = 0